var LocalStorageUtils = (function () {
    function LocalStorageUtils() {
    }
    LocalStorageUtils.setItem = function (key, data, encodeJSON) {
        if (encodeJSON === void 0) { encodeJSON = false; }
        if (encodeJSON)
            data = JSON.stringify(data);
        console.log('setItem', key, data);
        window.localStorage.setItem(key, data);
    };
    LocalStorageUtils.getItem = function (key, defaultValue, decodeJSON) {
        if (defaultValue === void 0) { defaultValue = null; }
        if (decodeJSON === void 0) { decodeJSON = false; }
        var v = window.localStorage.getItem(key);
        console.log('getItem', key, defaultValue, v);
        if (!v)
            return defaultValue;
        if (decodeJSON)
            v = JSON.parse(v);
        return v;
    };
    LocalStorageUtils.removeItem = function (key) {
        window.localStorage.removeItem(key);
    };
    LocalStorageUtils.clear = function () {
        window.localStorage.clear();
    };
    LocalStorageUtils.key = function (index) {
        return window.localStorage.key(index);
    };
    return LocalStorageUtils;
}());
export default LocalStorageUtils;
export function setItem(key, data, encodeJSON) {
    if (encodeJSON === void 0) { encodeJSON = false; }
    if (encodeJSON)
        data = JSON.stringify(data);
    window.localStorage.setItem(key, data);
}
export function getItem(key, defaultValue, decodeJSON) {
    if (defaultValue === void 0) { defaultValue = null; }
    if (decodeJSON === void 0) { decodeJSON = false; }
    var v = window.localStorage.getItem(key);
    if (!v)
        return defaultValue;
    if (decodeJSON)
        v = JSON.parse(v);
    return v;
}
export function removeItem(key) {
    window.localStorage.removeItem(key);
}
export function clear() {
    window.localStorage.clear();
}
export function key(index) {
    return window.localStorage.key(index);
}



//////////////////
// WEBPACK FOOTER
// ./src/utils/LocalStorageUtils.ts
// module id = 0Zbu
// module chunks = 10